import MuiAlert from '@material-ui/lab/Alert';
import { get as _get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { reduxStateMap, withReducerName } from '../redux/reduxMap';

const ServiceBreakNotification = connect((state) => ({ serviceBreak: _get(state, withReducerName(reduxStateMap.SERVICE_BREAK), null) }))(({ serviceBreak }) => {
    if (!serviceBreak) return <></>;
    return (
        <MuiAlert elevation={6} variant="filled" severity="info" style={{ marginBottom: '-48px', marginTop: '32px', textAlign: 'center', marginLeft: '32px', marginRight: '32px', background: '#0066cc' }}>
            {serviceBreak.Message}
        </MuiAlert>
    );
});

export default ServiceBreakNotification;
